import { render, staticRenderFns } from "./ChatId.vue?vue&type=template&id=92152372"
import script from "./ChatId.vue?vue&type=script&lang=js"
export * from "./ChatId.vue?vue&type=script&lang=js"
import style0 from "./ChatId.vue?vue&type=style&index=0&id=92152372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports